"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GeogroupAvatar = GeogroupAvatar;
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Avatar2 = _interopRequireDefault(require("@mui/material/Avatar"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const colors = ['#2AC682', '#BB8A1A', '#528BE8', '#F36565', '#FA823E', '#DD428D', '#CF58E1', '#743AEF', '#1589BB', '#268B1D', '#846858'];
function GeogroupAvatar({
  geogroup,
  color,
  size: _size,
  variant
}) {
  let firstLetter = geogroup?.title && String.fromCodePoint(geogroup.title.codePointAt(0) || 0);
  if (firstLetter?.match(/[a-z]/i)) firstLetter = firstLetter?.toUpperCase();
  const size = _size || 32;
  return geogroup ? geogroup.photo ? /*#__PURE__*/_react.default.createElement(_Avatar2.default, {
    src: geogroup.photo,
    sx: {
      backgroundColor: '#fff',
      border: variant === 'outlined' ? `1px solid #DDE0E7` : undefined,
      flexShrink: 0,
      height: size,
      width: size
    }
  }) : /*#__PURE__*/_react.default.createElement(_Avatar2.default, {
    sx: ({
      palette
    }) => ({
      bgcolor: color ? (0, _styles.lighten)(color, 0.8) : firstLetter ? (0, _styles.lighten)(colors[firstLetter.charCodeAt(0) % colors.length], 0.8) : palette.primary.light,
      color: color || (firstLetter ? colors[firstLetter.charCodeAt(0) % colors.length] : palette.primary.light),
      flexShrink: 0,
      fontSize: size >= 48 ? '1.5rem' : undefined,
      fontWeight: size >= 48 ? 700 : undefined,
      height: size,
      width: size
    })
  }, firstLetter) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    height: size,
    style: {
      flexShrink: 0
    },
    variant: "circular",
    width: size
  });
}